
      var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRadio = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 32,
  height: 32,
  textRendering: "geometricPrecision",
  viewBox: "0 0 32 32"
}, props), _image || (_image = /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAM1BMVEVMaXGgn6OfnqKgn6Kfn5+gn6Kfn6Gfn6Kgn6Kgn6L///+3trjo5+iop6rW1dfw7/DQz9EcdLeKAAAACnRSTlMAx2D/Fd9Ik+96fabmuAAAAAlwSFlzAAAD6AAAA+gBtXtSawAAAMdJREFUeNqVk+sWxBAMhKuhIjS8/9NuaHd7k1M7f+c7Q5hM07js4g0CoPFL1w5ifuWCvfvVjiVlIkocBZmvvhc70U9JEH/1V6aLeD0T4me6KZ+IueM3Iuz3d8DUEQNuswSI1FXcIxykPpC2iEULqBFLG4E1oLRBjHZCPcMIgKD5lAEFAB0ggBEAIesAjlzSQ9EAbmO+PpRF/and2GdJhPLdbq9u0Aozj1buvbTvtZfiOkG4MjkVsTE8V88dq4fP1as6ltf+sfMf6TsaIfGVskUAAAAASUVORK5CYII=",
  width: 32,
  height: 32,
  href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAM1BMVEVMaXGgn6OfnqKgn6Kfn5+gn6Kfn6Gfn6Kgn6Kgn6L///+3trjo5+iop6rW1dfw7/DQz9EcdLeKAAAACnRSTlMAx2D/Fd9Ik+96fabmuAAAAAlwSFlzAAAD6AAAA+gBtXtSawAAAMdJREFUeNqVk+sWxBAMhKuhIjS8/9NuaHd7k1M7f+c7Q5hM07js4g0CoPFL1w5ifuWCvfvVjiVlIkocBZmvvhc70U9JEH/1V6aLeD0T4me6KZ+IueM3Iuz3d8DUEQNuswSI1FXcIxykPpC2iEULqBFLG4E1oLRBjHZCPcMIgKD5lAEFAB0ggBEAIesAjlzSQ9EAbmO+PpRF/and2GdJhPLdbq9u0Aozj1buvbTvtZfiOkG4MjkVsTE8V88dq4fP1as6ltf+sfMf6TsaIfGVskUAAAAASUVORK5CYII=",
  preserveAspectRatio: "none"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"32\" height=\"32\" text-rendering=\"geometricPrecision\" viewBox=\"0 0 32 32\"><image xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAM1BMVEVMaXGgn6OfnqKgn6Kfn5+gn6Kfn6Gfn6Kgn6Kgn6L///+3trjo5+iop6rW1dfw7/DQz9EcdLeKAAAACnRSTlMAx2D/Fd9Ik+96fabmuAAAAAlwSFlzAAAD6AAAA+gBtXtSawAAAMdJREFUeNqVk+sWxBAMhKuhIjS8/9NuaHd7k1M7f+c7Q5hM07js4g0CoPFL1w5ifuWCvfvVjiVlIkocBZmvvhc70U9JEH/1V6aLeD0T4me6KZ+IueM3Iuz3d8DUEQNuswSI1FXcIxykPpC2iEULqBFLG4E1oLRBjHZCPcMIgKD5lAEFAB0ggBEAIesAjlzSQ9EAbmO+PpRF/and2GdJhPLdbq9u0Aozj1buvbTvtZfiOkG4MjkVsTE8V88dq4fP1as6ltf+sfMf6TsaIfGVskUAAAAASUVORK5CYII=\" width=\"32\" height=\"32\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAM1BMVEVMaXGgn6OfnqKgn6Kfn5+gn6Kfn6Gfn6Kgn6Kgn6L///+3trjo5+iop6rW1dfw7/DQz9EcdLeKAAAACnRSTlMAx2D/Fd9Ik+96fabmuAAAAAlwSFlzAAAD6AAAA+gBtXtSawAAAMdJREFUeNqVk+sWxBAMhKuhIjS8/9NuaHd7k1M7f+c7Q5hM07js4g0CoPFL1w5ifuWCvfvVjiVlIkocBZmvvhc70U9JEH/1V6aLeD0T4me6KZ+IueM3Iuz3d8DUEQNuswSI1FXcIxykPpC2iEULqBFLG4E1oLRBjHZCPcMIgKD5lAEFAB0ggBEAIesAjlzSQ9EAbmO+PpRF/and2GdJhPLdbq9u0Aozj1buvbTvtZfiOkG4MjkVsTE8V88dq4fP1as6ltf+sfMf6TsaIfGVskUAAAAASUVORK5CYII=\" preserveAspectRatio=\"none\"/></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/radio.0dd754ed2c0a2e94b1c7fd817dabe9e2.svg"),
        {
          React: SvgRadio,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      